<div *ngIf="members" class="w-full p-4 flex flex-row justify-between items-center h-24 border-b-2">
    <div class="w-[50%] flex flex-row justify-between items-center">
        <div class="flex flex-col">
            <span class="italic font-thin">{{ 'STATE' | translate }}</span>
            <div class="flex flex-row items-center gap-2">
                <ng-container *ngIf="!hasPreemptiveRefusal">
                    <span [className]="'rounded-full w-3 h-3 bg-' + main_member?.status || ''"></span>
                    <span class="font-extrabold italic">{{ ('MEMBERS_STATUS.' + main_member?.status) | uppercase | translate}}</span>
                </ng-container>
                <ng-container *ngIf="hasPreemptiveRefusal">
                    <span [className]="'rounded-full w-3 h-3 bg-reject'"></span>
                    <span class="font-extrabold italic"> {{ 'MEMBERS_STATUS.REJECT' | translate }}</span>
                </ng-container>
            </div>
        </div>
        <div class="flex flex-col">
            <span class="italic font-thin">{{ 'APPROVAL_SENT' | translate }}</span>
            <span class="font-extrabold italic">{{ current_approval_number }} / {{ total_approval_number }}</span>
        </div>
    </div>
    <button mat-flat-button class="h-10" (click)="openMembersModel()">
        <div class="flex flex-row gap-2 items-center justify-center">
            <strong>{{ 'SEE_ALL' | translate }}</strong>
            <mat-icon>visibility</mat-icon>
        </div>
    </button>
</div>